module.exports = __webpack_public_path__ + "img/download_for_offline_gray.dfac400d.svg";